module.exports = "\r\n\r\n@import 'https://fonts.googleapis.com/icon?family=Material+Icons';\n/* You can add global styles to this file, and also import other style files */\n.md-sidenav-content {\r\n  background-color: #F0F0F0;\r\n}\nmd-input-container {\r\n  padding-bottom: 2px;\r\n  font-size: 16px;\r\n}\n.mat-select-trigger {\r\n  margin: 9px 0;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./node_modules/postcss-loader/lib??embedded!./apps/nox/src/styles.css
// module id = ./node_modules/raw-loader/index.js!./node_modules/postcss-loader/lib/index.js??embedded!./apps/nox/src/styles.css
// module chunks = styles